// extracted by mini-css-extract-plugin
module.exports = {"column":"Wrapper_column__301lt","title":"Wrapper_title__3s_ZD"};